<template>
  <div>
    <v-server-table ref="table" :columns="columns" :options="options" :url="url" style="overflow: hidden;">
      <div slot="date_reception" slot-scope="props">
        {{ formatDate(props.row.created_at) }}
      </div>
      <div slot="utilisateur" slot-scope="props">
        {{ getUserById(props.row.gestionnaire) }}
      </div>
      <div slot="action" slot-scope="props">
        <span v-html="getLibelleAction(props.row)"></span>
      </div>
    </v-server-table>
  </div>
</template>

<script>
  import { isEmpty } from "@/utils/fileHelper";

  export default {
    name: "JournalQualite",
    data() {
      let self = this;
      return {
        journal: [],
        options: {
          headings: {
            'date_reception': "Date d'action",
            'utilisateur': 'Utilisateur',
            'action': 'Action',
          },
          filterable: false,
          perPage: 10,
          perPageValues: [1, 10, 25],
          sortable: ['date_reception'],
          requestFunction: function (data) {
            // TODO : Regarder si possible Passer en client-table avec data provenant de dossier.suivis (modifier le with avec sous requete lors de récupération infos dossiers)
            // et passage du dossier en props, afin d'éviter une requete supplémentaire à chaque modification du dossier
            self.url = '/espaceQualite/dossier/controle/getControleDossierJournalById/' + self.dossier.id;

            return axios.get(self.url, {
              params: data
            })
              .then(function(response){
                // console.log(response.data.data)
                return response;
              })
              .catch(function (e) {
                console.log(e);
              }.bind(this));
          },
        },
        columns: ['date_reception', 'utilisateur', 'action'],
        url: '',
      }
    },
    props: ['dossier'],
    mounted() {
      this.$event.on('refreshDossier', () => {
        if (!isEmpty(this.$refs.table)) {
          this.$refs.table.refresh();
        }
      });
    },
    methods: {
      formatDate(textDate) {
        return textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
      },
      getUserById(gestionnaire) {
        return gestionnaire ? `${gestionnaire.prenom} ${gestionnaire.nom}` : 'système';
      },
      getLibelleAction(suivi) {
        // console.log(suivi.action, suivi)
        let libelle = '';
        switch (true) {
          case /Changement de statut/.test(suivi.action) :
            let libelleStatus = suivi.status ? (suivi.status.parent ? suivi.status.parent.libelle_bo + ' - ' + suivi.status.libelle_bo : suivi.status.libelle_bo) : '';
            libelle = suivi.action + ' : &nbsp;<span class="text-success">' + libelleStatus;
            break;
          case /Affectation/.test(suivi.action) :
          case /Desaffectation/.test(suivi.action) :
            libelle = suivi.action;
            if (suivi.gestionnaireAffecte) {
              libelle = suivi.action + ' à : &nbsp;<span class="text-warning"> ' + suivi.gestionnaireAffecte.prenom + ' ' + suivi.gestionnaireAffecte.nom;
            }
            break;
          case /Attachement/.test(suivi.action) :
          case /Détachement/.test(suivi.action) :
            libelle = suivi.action + ' à la campagne : &nbsp;<span class="text-info"> ' + suivi.commentaire;
            break;
          case /Ajout de pièce jointe/.test(suivi.action) :
          case /Suppression de pièce jointe/.test(suivi.action) :
            libelle = suivi.action + ' : <span class="text-warning">' + suivi.commentaire + '</span>';
            break;
          case /Création du contrôle/.test(suivi.action) :
          case /Modification du contrôle/.test(suivi.action) :
          default:
            libelle = suivi.action;
        }

        return libelle;
      },
    }
  }
</script>
